import { render } from "./GroupNameSearch.vue?vue&type=template&id=54386d24&scoped=true"
import script from "./GroupNameSearch.vue?vue&type=script&lang=js"
export * from "./GroupNameSearch.vue?vue&type=script&lang=js"

import "./GroupNameSearch.vue?vue&type=style&index=0&id=54386d24&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54386d24"]])

export default __exports__